import { render, staticRenderFns } from "./LifePhoto.vue?vue&type=template&id=1785477b&scoped=true&"
import script from "./LifePhoto.vue?vue&type=script&lang=js&"
export * from "./LifePhoto.vue?vue&type=script&lang=js&"
import style0 from "./LifePhoto.vue?vue&type=style&index=0&id=1785477b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785477b",
  null
  
)

export default component.exports